import { ChangeEvent } from 'react';
import { FormInput, Wrapper } from './styles';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import { ErrorMessage } from '../ErrorMessage';
import { IInput } from '../Input/Input';

export interface IHookFormInput extends IInput {
  name: string;
  label?: string;
  placeholder?: string;
  className?: string;
  rules?: RegisterOptions<any, string>;
  onClearInput?: () => void;
  error?: string;
  disabled?: boolean;
  readonly?: boolean;
  onChangeValue?: () => void;
  PrefixElement?: () => JSX.Element;
}

export const HookFormInput = ({
  name,
  label,
  placeholder,
  className,
  rules,
  onClearInput,
  error,
  disabled,
  readonly = false,
  onChangeValue,
  PrefixElement,
  ...props
}: IHookFormInput) => {
  const { setValue, watch, register } = useFormContext();

  if (rules) {
    register(name, {
      ...rules,
    });
  }

  const handleBlur = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(name, e.target?.value.trim(), { shouldValidate: true, shouldDirty: true });
  };

  const handleChange = (readonly) ? undefined : (e: ChangeEvent<HTMLInputElement>) => {
    setValue(name, e.currentTarget.value, { shouldValidate: true, shouldDirty: true });
    onChangeValue && onChangeValue();
  };

  const value = watch(name);

  return (
    <Wrapper>
      <FormInput
        disabled={disabled}
        label={label}
        name={name}
        className={className}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        onClearInput={(readonly) ? undefined : onClearInput}
        data-testid={props['data-testid']}
        PrefixElement={PrefixElement}
        shouldRenderPrefix={!!PrefixElement}
      />

      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Wrapper>
  );
};
